export default __webpack_public_path__ + "static/IBMPlexSans-Bold-Latin1-61977c7d4322f4574bf8a180307997ae.woff";